import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  GetRubDetails,
  AddRub,
  DeleteRub,
  UpdateRub,
} from "../../../../api/User/ACG/RUBsApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import { Plan } from "../../../../Utils/constants";
import CustomInputField from "../../../../components/common/CustomInputField";
import ReactTooltip from "react-tooltip";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  plan: Yup.string().notOneOf(["Select Plan"], "Please select plan").required("Please select paln"),
  enrollment_PCT: Yup.number()
    .min(0, "Number must be positive")
    .typeError("Please enter a valid number")
    .required("Please enter enrollment PCT"),
  claim_PCT: Yup.number()
    .min(0, "Number must be positive")
    .typeError("Please enter a valid number")
    .required("Please enter claim PCT"),
});

const RUBs = () => {
  const [data, setData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Plan", field: "plan" },
    {
      title: "Enrollment Percentage",
      field: "enrollment_PCT",
      render: (rowData) => (+rowData.enrollment_PCT  * 100).toFixed(2)+ "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.enrollment_PCT  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "Claim Percentage",
      field: "claim_PCT",
      render: (rowData) => (+rowData.claim_PCT * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.claim_PCT  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getRubDetailsData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getRubDetailsData();
  }, []);

  const getRubDetailsData = () => {
    GetRubDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { plan, enrollment_PCT, claim_PCT } = values;
    const payload = {
      id: 0,
      plan,
      enrollment_PCT: +enrollment_PCT,
      claim_PCT: +claim_PCT,
    };

    if (witchAction === "add") {
      AddRub(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("new");
        setShowModal(false);
        }else if (res?.response?.status === 400) {
          toastFile(res?.response?.data,'error');
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateRub(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
        }else if (res?.response?.status === 400) {
          toastFile(res?.response?.data,'error');
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            RUBs
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteRub(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                plan: selectedRowData?.plan ?? "Select Plan",
                enrollment_PCT: selectedRowData?.enrollment_PCT ?? 0,
                claim_PCT: selectedRowData?.claim_PCT ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Plan<Required/>
                      </Form.Label>
                      <img
                        data-tip=""
                        src={require("../../../../assets/icon/Question_mark_back.png")}
                        style={{ height: 15, marginLeft: 3 }}
                      />
                      <ReactTooltip
                        clickable
                        className="w-50 border-2 border-info p-3"
                        border
                        backgroundColor="white"
                        textColor="black"
                        place="right"
                      >
                        <b>Unknown:</b>
                        Members with an unknown RUB represent claimants who have
                        not interacted with the health plan, have ill-defined
                        claims or diagnosis codes or those with clinically
                        insignificant claims. As a result, their future health
                        care needs in the next 12-months are unknown.
                        <br />
                        <b>Very Low:</b> Members in this RUB are those with
                        healthy utilization that suggests the future utilization
                        in the next 12-months will be very low. It is typical to
                        see members who are compliant with preventive care, no
                        gaps in care and have demographics that tend to indicate
                        healthier/low-morbidity.
                        <br />
                        <b>Low:</b> Members in this RUB have some clinically
                        significant diagnoses with the low probability of having
                        expansive health care needs in the next 12-months. It is
                        common to find members with common, non-severe
                        conditions in this category or conditions that are
                        limited in duration and/or show little to no gaps in
                        care and strong adherence to preventive care.
                        <br />
                        <b>Moderate:</b> Members within this RUB show a mix of
                        minor/major, acute/chronic and severe/non-severe
                        conditions. Their utilization indicates the need for
                        ongoing health care needs and may be moderate in nature.
                        Members in this category tend to have consistent gaps in
                        care and often do not demonstrate consistency in
                        preventive care compliance. Members who remain unstable
                        are likely to migrate into progressive RUB categories.
                        <br />
                        <b>High:</b> Members in this RUB, like the Moderate
                        category have various health care utilization, most of
                        which is chronic, severe and ongoing. In some instances,
                        acute major and time limited majors (such as pregnancy
                        with complications or trauma) can place one in this
                        category and once controlled or stabilized may migrate
                        to a lower RUB. Members in the High RUB; however, are
                        likely to have significant health care needs in the next
                        12-months and should be monitored carefully for
                        catastrophic risk.
                        <br />
                        <b>Very High: </b> Members in this RUB have severe,
                        acute, non-compliant chronic and life-threatening
                        conditions. They are conditions that tend to be
                        catastrophic and some of the more costly types of
                        conditions in the health care system. Members in this
                        category are not likely to demonstrate low utilization
                        patterns in the future and are expected to have
                        extensive health care needs in the next 12-months.
                        Members in this category should be monitored closely for
                        catastrophic risk and stop loss claims activity.
                      </ReactTooltip>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.label}
                        name="plan"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.plan && errors.plan}
                      >
                        {Plan.map((item) => (
                          <option value={item} selected={values.plan === item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.plan}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <CustomInputField
                      label="Enrollment Percentage"
                      name="enrollment_PCT"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Claim Percentage"
                      name="claim_PCT"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add RUBs
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
      />
    </div>
  );
};

export default RUBs;
